export default __webpack_public_path__ + "static/precipitation_and_evaporation-746679a6fd385f1b07e76c669360095f.jpg";